import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from '../utils/constants.js';

const hasConfig = SUPABASE_URL && SUPABASE_ANON_KEY;

export const supabase = hasConfig
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true
      }
    })
  : null;

export function isSupabaseReady() {
  return !!supabase;
}

export async function getCurrentUser() {
  if (!supabase) return null;
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) return null;
  const { data: { user } } = await supabase.auth.getUser();
  return user;
}

export async function getProfile(userId) {
  if (!supabase) return null;
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', userId)
    .single();
  if (error) return null;
  return data;
}

function getAuthRedirectTo() {
  return window.location.origin;
}

export async function signInWithProvider(provider) {
  if (!supabase) throw new Error('Supabase non configuré. Ajoute VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY dans .env');
  const options = {
    redirectTo: getAuthRedirectTo()
  };
  const { error } = await supabase.auth.signInWithOAuth({
    provider,
    options
  });
  if (error) throw error;
}

export async function signInWithGoogle() {
  return signInWithProvider('google');
}

export async function signInWithEmail(email) {
  if (!supabase) throw new Error('Supabase non configuré. Ajoute VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY dans .env');
  const { error } = await supabase.auth.signInWithOtp({
    email,
    options: {
      emailRedirectTo: getAuthRedirectTo()
    }
  });
  if (error) throw error;
}

export async function signOut() {
  if (!supabase) return;
  await supabase.auth.signOut();
}
